export default __webpack_public_path__ + "static/media/our_breakfast@2x.4583ed2e.png";